import { render, staticRenderFns } from "./LocaleSelect.vue?vue&type=template&id=51344138&scoped=true"
import script from "./LocaleSelect.vue?vue&type=script&lang=js"
export * from "./LocaleSelect.vue?vue&type=script&lang=js"
import style0 from "./LocaleSelect.vue?vue&type=style&index=0&id=51344138&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51344138",
  null
  
)

export default component.exports